<template>
  <v-container class="home">
    <v-row class="my-2">
      <v-col>
        <v-sheet outlined style="text-align: center" class="crane-border-purple">
          <v-row>
            <v-col><h2 class="mt-5">Resources</h2></v-col>
          </v-row>
          <v-row>
              <v-col>  
                <a href="https://docs.google.com/document/d/1L-9IQVJ7GfT_NyHTaJ8p27DwoAr1R2WH24dS-wcR1Ds/" target="_blank">CS167/69 & CS267 Syllabus</a>
              </v-col>
          </v-row>
          <v-row>
              <v-col>  
                <a href="content/CS167_169_267_Collaboration_Policy.pdf" target="_blank">Collaboration Policy</a>
              </v-col>
          </v-row>
          <v-row>
              <v-col>  
                <a href="https://github.com/brown-cs1690/handout/wiki" target="_blank">Handout Wiki</a>
              </v-col>
          </v-row> 
          <v-row>
              <v-col>  
                <a href="https://github.com/brown-cs1690/handout/wiki/Github-and-Gradescope" target="_blank">Github and Gradescope Guide</a>
              </v-col>
          </v-row>
          <v-row>
              <v-col>  
                <a href="https://github.com/brown-cs1690/handout/wiki/Vagrant-Guide" target="_blank">Developing Locally</a>
              </v-col>  
          </v-row>
					<v-row>
							<v-col>
								<a href="https://edstem.org/us/courses/19359/discussion/" target="_blank">EdStem</a>
							</v-col>
					</v-row>
					<v-row>
            <v-col><h2 class="mt-5">Help Sessions</h2></v-col>
          </v-row>
          <v-simple-table class="ma-3" style="text-align: left">
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Project</th>
                  <th>Slides</th>
                  <th>Recording</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in sessions" :key="item.project">
                  <td>{{ item.date }}</td>
                  <td>{{ item.project }}</td>
                  <td>
                    <a v-if="item.slides" :href="item.slides" target="_blank" >Slides</a>
                    <span v-else>Slides</span>
                  </td>
                  <td>
                    <a v-if="item.recording" :href="item.recording" target="_blank" >Recording</a>
                    <span v-else>Recording</span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Home",
  components: {},
  data: () => ({
    sessions: [
      {
        date: "Jan 31, 7pm",
        project: "Uthreads",
        slides: "https://docs.google.com/presentation/d/10ekJBsSU2n14oegYoMU3gYbaq_lXXeBrcAWZH8lJWxM/edit?usp=sharing",
        recording: "https://drive.google.com/file/d/1cTpJjlqCoieodeB_Nk-vOri-IqJucgVi/view?usp=sharing",
      },
      {
        date: "Feb 3, 7pm",
        project: "Weenix - Procs",
        slides: "https://docs.google.com/presentation/d/1Id3DH-_qdHqgi5dB-Ne5VTtwS0j45ZpXWy-l_FP1SC8/edit?usp=sharing",
        recording: "https://drive.google.com/file/d/1vUyPjugS4S5VShDiEf_uI8MzHItsvIfF/view?usp=sharing",
      },
      {
        date: "Feb 14, 7pm",
        project: "Mthreads",
        slides: "https://docs.google.com/presentation/d/1LZAptzIe9Qj54jJlNohV7rYqgJ0pZPBySbSsl3UbZME/edit?usp=sharing",
        recording: "https://drive.google.com/file/d/1G3a4kVIyf0NdC43DZA3zc7OkBhJsUGrQ/view?usp=sharing",
      },
      {
        date: "Feb 17, 7pm",
        project: "Weenix - Drivers",
        slides: "https://docs.google.com/presentation/d/1FHNwnWt1bUxmDMJ0JrCRQ8P_hYT5i53MUlq5ovBFNaI/edit?usp=sharing",
        recording: "https://drive.google.com/file/d/1NdPG2634TS19n3X4pfdPp9iEtZflkGaE/view?usp=sharing",
      }, 
      {
        date: "Mar 3, 7pm",
        project: "Weenix - VFS",
        slides: "https://docs.google.com/presentation/d/1BllDeEjpzJ-vNEuVCffk_ot_JaBNrUF24cCE9YXXr0k/edit?usp=sharing",
        recording: "https://drive.google.com/file/d/1W7KJfThvzVWkjWwKmHKGh1ZZwZUXsl9P/view?usp=sharing",
      },
      {
        date: "Mar 14, 7pm",
        project: "VFS",
        slides: "https://docs.google.com/presentation/d/1YvefXRKEm1XagxJuQewReRTpmlI18L0FlL4Tj42BlP4/edit?usp=sharing",
        recording: "https://drive.google.com/file/d/1l3r3wtW0sXXms8EamKOLiUS-8WxIBx3n/view?usp=sharing",
      },
      {
        date: "Mar 24, 7pm",
        project: "S5FS",
        slides: "https://docs.google.com/presentation/d/1NsocVL_tWBveJwaU8dqRm0HQDBN0w051YsB35Z3cPwE/edit?usp=sharing",
        recording: "https://drive.google.com/file/d/1X10sl8ppjVahRedxZYZd6i1cd8mTSs-w/view?usp=sharing",
      },
      {
        date: "Apr 7, 7pm",
        project: "Weenix - VM",
        slides: "https://docs.google.com/presentation/d/1WQi-8uUZS6B3vx9s4rtNfMgfAWVHE1PnGMOyl6TRC-Y/edit?usp=sharing",
        recording: "https://drive.google.com/file/d/1hkGV7DxsC3Cc3NAoQ9PyYMQaUnkfLdZU/view?usp=sharing",
      },
    ]
  }),
};
</script>
<style scoped>

@import '../styles/crane.css';

.profile {
  width: 250px;
  margin: auto;
}

.profile img {
  width: 200px;
  height: 200px;
  object-fit: cover;
}
a {
    text-decoration: none;
}
</style>
